export default ({
    namespaced: true,
    state: {
        animatedClass: 'animated rubberBand',
        routerTransition: {
            parent: {
                enterActiveClass: "animated rotateInUpLeft",
                leaveActiveClass: "animated rotateOutDownRight",
                mode: "out-in"
            },
            child: {
                enterActiveClass: "animated zoomInUp",
                leaveActiveClass: "animated zoomOutDown",
                mode: "out-in"
            },
            list: {
                enterActiveClass: "animated bounceIn",
                leaveActiveClass: "animated bounceOut",
                mode: "out-in"
            },
            alternative: {
                enterActiveClass: "animated bounceInLeft",
                leaveActiveClass: "animated bounceOutRight",
                mode: "out-in"
            },
            alternative2: {
                enterActiveClass: "animated fadeIn",
                leaveActiveClass: "animated hinge",
                mode: "out-in"
            }
        },
    }
})
